import { Block } from '../block.js'
import { TextBlock } from './text-block.js'
import type { TsCodeType, EventType, NameAndType } from '../../types.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { BlockLinkDefinition } from '../common/block-link-definition.js'
import { BlockWithLink } from '../common/block-with-link.js'
import { ScreenEditorInput } from '../decorators/screen-editor-input.js'
import { TextOrExpression_assumeExpression } from '../../data/text-or-code.js'
import { BlockComponentImport } from '../block-component-import.js'

@jsonClass('LinkBlock')
export class LinkBlock extends Block implements BlockWithLink {
	@jsonProperty(BlockLinkDefinition)
	@ScreenEditorInput<LinkBlock>({
		order: 1,
		label: '',
		compositionObj: (blocks) => blocks[0].link,
	})
	link: BlockLinkDefinition = new BlockLinkDefinition()

	canAcceptVariableString = (variable: NameAndType) => variable.type == 'string'
	acceptVariableString = (variable: NameAndType) => {
		this.link.targetType = 'url'
		this.link.url = new TextOrExpression_assumeExpression(variable.name)
	}

	constructor(init: Partial<LinkBlock> = {}) {
		super()
		this.init(init)
	}

	static createNewForEditor(): Block {
		return new this({
			children: [new TextBlock({ text: 'Text' })],
		})
	}

	get allowedEventTypes(): EventType[] {
		return [{ name: 'click' }, { name: 'dblclick' }]
	}

	getPreviewDirection(): 'row' | 'column' {
		return 'row'
	}

	getEditorCategory(): string {
		return 'Core'
	}
}
